import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import PaginationComponent from '@Components/Tables/Pagination'
import { StoresContext } from '@App/contexts'
import { PaginationBody } from '@Entities/pagination'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import { getNumTitles } from '@App/helpers/pagination/get-num-titles'
import { SearchResultPartyDetails } from '@Entities/party-details'
import CowriterSearchResultRowData from '@Scenes/SongwriterScene/CowriterSearch/CowriterSearchScene/CowriterSearchResultsTable/CowriterSearchResultRowData'

interface CowriterSearchResultsProps {
    data: SearchResultPartyDetails[]
    onSelectWriter: (writer: SearchResultPartyDetails) => void
    onPaginationChange: (body: PaginationBody) => void
}

const CowriterSearchResults = ({ data, onSelectWriter, onPaginationChange }: CowriterSearchResultsProps) => {
    const { cowriterSearchPartyStore } = useContext(StoresContext)

    const getNumTitlesForSearchResults = () =>
        getNumTitles(
            cowriterSearchPartyStore.searchResults?.length ?? 0,
            cowriterSearchPartyStore.searchByCriteriaPaginationInfo?.currentPage ?? 1,
            cowriterSearchPartyStore.resultsPerPageLimit ?? 10
        )

    return (
        <>
            <PaginationResultsBlock
                workNumTitles={getNumTitlesForSearchResults()}
                totalResults={cowriterSearchPartyStore.totalNumberOfResults ?? 0}
                hideNoResults
            />
            {data?.length > 0 ? (
                <table className="cowriter-link-table">
                    <colgroup>
                        <col className="cowriter-name-col" />
                        <col className="cowriter-toggle-col" />
                    </colgroup>
                    <thead>
                        <tr>
                            <td>Writer Name</td>
                            <td>Number of Songs</td>
                        </tr>
                    </thead>
                    <tbody>
                        <CowriterSearchResultRowData data={data} onSelectWriter={onSelectWriter} />
                    </tbody>
                </table>
            ) : (
                <span> Results Not Found. </span>
            )}
            <PaginationComponent
                limit={cowriterSearchPartyStore.resultsPerPageLimit ?? 10}
                paginationPages={cowriterSearchPartyStore.searchByCriteriaPaginationInfo}
                onChange={onPaginationChange}
            />
        </>
    )
}

export default observer(CowriterSearchResults)
